//Import required libraries
import React from 'react';

//Import custom components
import Admin from '../components/photographer/admin/Admin'

//Import Styles

const PhotographerAdmin = () => {
    
  return (
      <Admin />
  );
}

export default PhotographerAdmin;
